<script>
export default {
  data: () => ({
    name: '',
    email: '',
  }),

  computed: {
    validationError() {
      if (!this.name) return 'Please enter a Name';
      if (!this.email) return 'Please enter a Email';

      return undefined;
    },
  },
}
</script>

<template>
  <api-form
    method="put"
    url="v1/tenant/configuration/admin-recipient"
    :payload="{ name: name, email: email }"
    submit-text="Add"
    :validation-error="validationError"
    @success="$emit('added', $event)"
    @cancel="$emit('cancel')">

    <b-form-group label="Name" :label-for="`name-${_uid}`">
      <b-form-input :id="`name-${_uid}`" v-model="name" type="text" placeholder="John Doe" required></b-form-input>
    </b-form-group>

    <b-form-group label="Email" :label-for="`email-${_uid}`">
      <b-form-input :id="`email-${_uid}`" v-model="email" type="text" placeholder="john.doe@email.com" required></b-form-input>
    </b-form-group>

  </api-form>
</template>



// WEBPACK FOOTER //
// src/tenant/components/AdminRecipientAddForm.vue